import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../services/api.service';

@Pipe({
  name: 'authImage'
})
export class AuthImagePipe implements PipeTransform {

  constructor(private httpClient: HttpClient,
              private domSanitizer: DomSanitizer,
              private apiService: ApiService) {
  }

  transform(value: any, ...args: any[]): Promise<SafeStyle> {
    return new Promise(resolve => {
      if (value) {
        this.apiService.getItemImageAsString(value)
          .subscribe(image => {
            // const imageBlob: Blob = new Blob([image], {type: 'image/jpeg'});
            const imageBlob = this.b64toBlob(image);
            if (args[0] && args[0] === 'img') {
              resolve(this.domSanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(imageBlob)));
            } else {
              const imageStyle = `url(${window.URL.createObjectURL(imageBlob)})`;
              resolve(this.domSanitizer.bypassSecurityTrustStyle(imageStyle));
            }
          }, error => {
            console.log('error:', error);
          });
      } else {
        resolve();
      }
    });
  }

  b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

}
